import { Entity, Nullable } from '@Models';

export type EntityIdKey = string | number | Entity<number> | Entity<string>;
export type EntityKey = EntityIdKey | EntityIdKey[];

export type EntityLoadingState = {
  hasError: boolean;
  isLoading: boolean;
  errorMessage: Nullable<string>;
};

export type EntityState<T extends EntityKey> = EntityLoadingState & {
  entity: Nullable<T>;
};

export type buildLoadingState = (
  data: Partial<EntityLoadingState>,
) => EntityLoadingState;

export const buildEntityLoadingState: buildLoadingState = (
  data: Partial<EntityLoadingState> = {},
) => {
  return {
    hasError: data.hasError ?? false,
    errorMessage: data.errorMessage ?? null,
    isLoading: data.isLoading ?? false,
  };
};

export type buildState = <T extends EntityKey>(
  data: Partial<EntityState<T>>,
) => EntityState<T>;

export const buildEntityState: buildState = <T extends EntityKey>(
  data: Partial<EntityState<T>> = {},
) => {
  return {
    ...buildEntityLoadingState(data),
    entity: data.entity ?? null,
  };
};
